import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import "react";
import * as __WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__ from "lucide-react";
import * as __WEBPACK_EXTERNAL_MODULE_react_day_picker_7bc423fd__ from "react-day-picker";
import * as __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__ from "../lib/utils.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__ from "./button.mjs";
function Calendar({ className, classNames, showOutsideDays = true, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_day_picker_7bc423fd__.DayPicker, {
        showOutsideDays: showOutsideDays,
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("p-3 select-none", className),
        classNames: {
            months: "flex flex-col sm:flex-row gap-2",
            month: "flex flex-col gap-4",
            caption: "flex justify-center pt-1 relative items-center w-full",
            caption_label: "text-sm font-normal",
            nav: "flex items-center gap-1",
            nav_button: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)((0, __WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.buttonVariants)({
                variant: "tertiary"
            }), "size-7 bg-transparent p-0 opacity-50 hover:opacity-100"),
            nav_button_previous: "absolute left-1",
            nav_button_next: "absolute right-1",
            table: "w-full border-collapse space-x-1",
            head_row: "flex",
            head_cell: "text-muted-foreground rounded-md w-[34px] font-normal text-[0.8rem]",
            row: "flex w-full mt-2",
            cell: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("relative p-[1px] text-center text-sm focus-within:relative focus-within:z-20 [&:has([aria-selected])]:bg-accent [&:has([aria-selected].day-range-end)]:rounded-r-md", "range" === props.mode ? "[&:has(>.day-range-end)]:!rounded-r-md [&:has(>.day-range-start)]:!rounded-l-md first:[&:has([aria-selected])]:!rounded-l-md last:[&:has([aria-selected])]:!rounded-r-md" : "[&:has([aria-selected])]:!rounded-md"),
            day: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)((0, __WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.buttonVariants)({
                variant: "ghost"
            }), "size-8 p-0 font-normal aria-selected:opacity-100"),
            day_range_start: "day-range-start aria-selected:bg-primary aria-selected:text-primary-foreground",
            day_range_end: "day-range-end aria-selected:bg-primary aria-selected:text-primary-foreground",
            day_selected: "bg-brand-primary/20 !text-brand-primary hover:!bg-brand-primary/[0.15] hover:!text-brand-primary/70 focus:bg-primary focus:text-primary-foreground",
            day_today: "bg-brand-primary/20 !text-brand-primary",
            day_outside: "day-outside text-muted-foreground aria-selected:text-muted-foreground",
            day_disabled: "text-muted-foreground opacity-50",
            day_range_middle: "aria-selected:bg-accent aria-selected:text-accent-foreground",
            day_hidden: "invisible",
            ...classNames
        },
        components: {
            IconLeft: ({ className, ...props })=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.ChevronLeft, {
                    className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("size-4", className),
                    ...props
                }),
            IconRight: ({ className, ...props })=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.ChevronRight, {
                    className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("size-4", className),
                    ...props
                })
        },
        ...props
    });
}
export { Calendar };
